// extracted by mini-css-extract-plugin
export default {"cell":"XnI8lzOlDTE1s6WKjI2u","fadeIn":"dEKVGsXqaLYhEOwlRMCY"};